import _ from 'lodash'
import { CancelToken } from 'axios'

import { MydAPI } from '_services/default'
import {
  FETCHING_NOTIFICATIONS,
  FETCHED_NOTIFICATIONS,
  READ_NOTIFICATION,
  DELETE_NOTIFICATION,

  DELETED_MESSAGE_COLLECTION,
  DELETED_MESSAGE_WIDGET,
  DELETED_PRIVATE_MESSAGE_WIDGET,
  EVALUATION_DONE_BY_TEACHER,
  EVALUATION_IN_1_DAYS,
  EVALUATION_IN_6_DAYS,
  EVALUATION_REQUESTED_BY_STUDENT,
  ICT_PLANNING_TASK_REMOVED,
  NEW_MESSAGE_COLLECTION,
  NEW_MESSAGE_WIDGET,
  NEW_PRIVATE_MESSAGE_WIDGET,
  PLANNING_DELETED,
  PLANNING_STARTED,
  PLANNING_TASK_RESCHEDULED,
  USER_ADDED_TO_COLLECTION,
  USER_REMOVED_FROM_COLLECTION,
  WIDGET_LIKED,
} from '_reducers/notifications'

import _t from 'utils/i18n_helper'


const proccessNotificationType = (notification) => {
  let text

  switch(notification.attributes.type) {

    case(NEW_MESSAGE_WIDGET):
      return {
        type: 'NEW_MESSAGE_WIDGET',
        text: _t('NEW_MESSAGE_WIDGET', true),
        linkContent: `/widgets/${notification.attributes.targetId}`
      }

    case(DELETED_MESSAGE_WIDGET):
      return {
        type: 'DELETED_MESSAGE_WIDGET',
        text: 'Message eliminated',
        linkContent: `/widgets/${notification.attributes.targetId}`
      }

    case(NEW_MESSAGE_COLLECTION):
      return {
        type: 'NEW_MESSAGE_COLLECTION',
        text: 'about collection',
        linkContent: `/widgets/${notification.attributes.targetId}`
      }

    case(DELETED_MESSAGE_COLLECTION):
      return {
        type: 'DELETED_MESSAGE_COLLECTION',
        linkContent: `/widgets/${notification.attributes.targetId}`
      }

    case(USER_ADDED_TO_COLLECTION):
      return {
        type: 'USER_ADDED_TO_COLLECTION',
        text: _t('USER_ADDED_TO_COLLECTION', true),
        linkContent: `/widgets/${notification.attributes.targetId}`
      }

    case(USER_REMOVED_FROM_COLLECTION):
      return {
        type: 'USER_REMOVED_FROM_COLLECTION',
        text: _t('USER_REMOVED_FROM_COLLECTION', true),
        linkContent: `/widgets/${notification.attributes.targetId}`
      }

    case(EVALUATION_REQUESTED_BY_STUDENT):
      return {
        type: 'EVALUATION_REQUESTED_BY_STUDENT',
        text: _t('EVALUATION_REQUESTED_BY_STUDENT', true),
        linkContent: `/widgets/${notification.attributes.targetId}/evaluation/evaluate`
      }

    case(EVALUATION_DONE_BY_TEACHER):
      return {
        type: 'EVALUATION_DONE_BY_TEACHER',
        text: _t('EVALUATION_DONE_BY_TEACHER', true),
        linkContent: `/widgets/${notification.attributes.targetId}/evaluation`
      }

    case(NEW_PRIVATE_MESSAGE_WIDGET):
      return {
        text: _t('NEW_PRIVATE_MESSAGE_WIDGET', true),
        type:'NEW_PRIVATE_MESSAGE_WIDGET',
        linkContent: `/widgets/${notification.attributes.targetId}`
      }

    case(DELETED_PRIVATE_MESSAGE_WIDGET):
      return {
        text: 'DELETED_PRIVATE_MESSAGE_WIDGET',
        type: 'DELETED_PRIVATE_MESSAGE_WIDGET',
        linkContent: `/widgets/${notification.attributes.targetId}`
      }

    case(PLANNING_STARTED):
      return {
        type: 'PLANNING_STARTED',
        text: _t('PLANNING_STARTED', true),
        linkContent: `${notification.attributes.url}?plId=${notification.attributes.targetId}`
      }

    case(PLANNING_DELETED):
      text = _t('PLANNING_DELETED', true).replace('{PLANNING_NAME}', notification.attributes.title)
      return {
        type: 'PLANNING_DELETED',
        text: text,
        linkContent: `${notification.attributes.url}`
      }

    case(WIDGET_LIKED):
      text = _t('WIDGET_LIKED', true).replace('{STORY_NAME}', notification.attributes.title)
      return {
        text: text,
        type: 'WIDGET_LIKED',
        linkContent: `${notification.attributes.url}`,
      }

    case(ICT_PLANNING_TASK_REMOVED):
      text = _t('PLANNING_TASK_REMOVED', true).replace('{TASK_NAME}', notification.attributes.excerpt)
      text = text.replace('{PLANNING_NAME}', notification.attributes.title)
      return {
        type: 'ICT_PLANNING_TASK_REMOVED',
        text: text,
        linkContent: `${notification.attributes.url}`
      }

    case(PLANNING_TASK_RESCHEDULED):
      text = _t('PLANNING_TASK_RESCHEDULED', true).replace('{TASK_NAME}', notification.attributes.excerpt)
      return {
        type: 'PLANNING_TASK_RESCHEDULED',
        text: text,
        linkContent: `${notification.attributes.url}`
      }

    case(EVALUATION_IN_1_DAYS):
      text = _t('EVALUATION_IN_1_DAYS', true).replace('{TASK_NAME}', notification.attributes.title)
      return {
        type: 'EVALUATION_IN_1_DAYS',
        text: text,
        linkContent: `${notification.attributes.url}`
      }

    case(EVALUATION_IN_6_DAYS):
      text = _t('EVALUATION_IN_6_DAYS', true).replace('{TASK_NAME}', notification.attributes.title)
      return {
        type: 'EVALUATION_IN_6_DAYS',
        text: text,
        linkContent: `${notification.attributes.url}`
      }

    default:
      return notification
  }
}

export const deserializeNotificationsData = (data, included) => {

  return _.map(data, notification => {
    const { id, attributes, relationships, attributes: { target } } = notification

    let user
    if(_.get(relationships, 'senderUser.data.id', false)) {
      const dataUser = _.find(included, {
        type: 'user',
        id: _.parseInt(relationships.senderUser.data.id, 10),
      })

      user = {
        ...dataUser.attributes,
        avatar: dataUser.attributes.avatar.tiny,
        id: dataUser.id,
      }
    } else {
      user = {
        avatar: 'https://s3-eu-west-1.amazonaws.com/myd-resources/icons/icon_mydocumenta.png',
        firstName: 'System',
        lastName: null,
      }
    }

    return {
      id,
      user,
      contentTitle: _.get(target, 'data.attributes.name', ''),
      content: proccessNotificationType(notification),
      date: attributes.timestamp,
      notificationStatus: {
        isRead: attributes.isRead,
      }
    }
  })
}

const fetchingNotifications = (append=false) => ({
  type: FETCHING_NOTIFICATIONS,
  append,
})

const fetchedNotifications = (notifications, meta, append=false) => ({
  type: FETCHED_NOTIFICATIONS,
  notifications,
  meta,
  append,
})

const readNotification = notificationId => ({
  type: READ_NOTIFICATION,
  notificationId,
})

const deleteNotification = notificationId => ({
  type: DELETE_NOTIFICATION,
  notificationId,
})


let fetchNotificationsCancelToken = null

export function fetchNotifications(page=1, size=10, append=false) {
  return dispatch => {
    return new Promise((resolve, reject) => {

      dispatch(fetchingNotifications(append))

      if (fetchNotificationsCancelToken) {
        fetchNotificationsCancelToken()
      }

      MydAPI.get(
        '/notifications',
        {
          cancelToken: new CancelToken(function executor(c) {
            fetchNotificationsCancelToken = c
          }),
          params: {
            sort:'-timestamp',
            'page[size]': size,
            'page[number]': page,
            'include': 'sender_user',
            'fields[user]': 'avatar,first_name,last_name',
            'fields[notification]': 'type,title,url,excerpt,target_id,target,sender_user,timestamp,id,is_read',
          }
        }
      ).then(notifications => {
        let retNotifications = deserializeNotificationsData(notifications.data.data, notifications.data.included)

        dispatch(fetchedNotifications(retNotifications, notifications.data.meta, append))
        resolve(retNotifications)

      }).catch(err => {
        if (err.__CANCEL__ !== true) {
          reject(err)
        }
      })
    })
  }
}

export function changeNotificationStatus(notificationId, action) {
  return dispatch => {
    return new Promise((resolve, reject) => {
      let request

      switch(action) {
        case('read'):
          dispatch(readNotification(notificationId))
          request= `notifications/${notificationId}/read`
          break
        case('delete'):
          dispatch(deleteNotification(notificationId))
          request= `notifications/${notificationId}/delete`
          break
        default:
          break
      }

      MydAPI.put(request).then(res=> {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  }
}
